var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),[_c('app-features'),_c('app-commodity'),_c('app-testimonials'),_c('app-contact')],_c('app-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }